import { guid, parseQueryString } from 'core-framework/util/CommonUtils';
import { getBootstrapConfig } from 'core/window/windowService';

const isWgDebug = (): boolean => {
    const qs = parseQueryString();
    return qs ? qs.iswgdebug === 'true' : false;
};

const numberToString = (value?: number, defaultValue = '') => {
    if (value === null || value === undefined) {
        return defaultValue;
    }
    return value.toString();
};

const getIdentityToken = (clientId: string, config = getBootstrapConfig()) => {
    return config.identityTokens[clientId] || '';
};

export const buildGraphQlHttpHeaders = (config = getBootstrapConfig()): Record<string, string> => {
    const headers: Record<string, string> = {
        'Content-Type': 'application/json',
        'AG-LANGUAGE-LOCALE': config.language.cultureCode || 'en-us',
        'AG-REQUEST-ID': guid(),
        'AG-RETRY-ATTEMPT': '0',
        'AG-REQUEST-ATTEMPT': '1',
        'Access-Control-Max-Age': '7200',
        'AG-ANALYTICS-SESSION-ID': config.analyticsSessionId,
        'AG-CORRELATION-ID': config.correlationId,
        'AG-CID': numberToString(config.pageConfig.cid, '1'),
        'AG-LANGUAGE-ID': numberToString(config.language.languageId, '1'),
        'AG-LANGUAGE-GROUP-ID': numberToString(config.language.languageGroupId, '1'),
        'AG-ORIGIN': config.pageConfig.origin,
        'AG-PLATFORM-ID': numberToString(config.userDevice.platformId),
        'AG-WHITELABEL-ID': numberToString(config.pageConfig.whitelabelid, '1'),
        'AG-WHITELABEL-TOKEN': config.whiteLabelConfig.whiteLabelKey,
        'AG-USE-MOCK': config.isUseAapiMock.toString(),
        'AG-ACTIVITIES-CLIENT-ID': 'activities-web',
        'AG-ACTIVITIES-CLIENT-CONTEXT-ID': config.pageConfig.pageTypeId.toString(),
        'AG-ACTIVITIES-IDENTITY-TOKEN': getIdentityToken('activities-web'),
        'AG-MSE-PRICING-TOKEN': config.multiProductMse.cookieValue,
        'AG-TRAFFIC-GROUP': numberToString(config.pageConfig.trafficGroupId, 'undefined'),
        'AG-TRAFFIC-SUB-GROUP': numberToString(config.pageConfig.trafficSubGroupId, 'undefined'),
    };

    if (config.feMessagingConfig.environment === 'development') {
        // INFO: Used for local testing
        headers['AG-ANALYTICS-SESSION-ID'] = '57d3da2a-cbc1-46ef-be21-23256f09c7ff';
        headers['AG-CORRELATION-ID'] = '608df06a-87bf-11eb-8dcd-0242ac130003';
        headers['AG-ORIGIN'] = config.pageConfig.origin || 'TH';
        headers['AG-USER-ID'] = config.userId || '759a1498-87bf-11eb-8dcd-0242ac130003';
    }

    if (isWgDebug()) {
        headers['ag-debug-log'] = 'true';
    }
    return headers;
};
